import React from 'react'
import { Route, Switch } from 'react-router'
import { HomeScreenBannersList } from './pages/List'
import { CreateHomeScreenBanner } from './pages/Create'
import { UpdateHomeScreenBanner } from './pages/Update'

export const HomeScreenBannerRouter = () => (
  <Switch>
    <Route exact path='/home-screen-banner' component={HomeScreenBannersList} />
    <Route exact path='/home-screen-banner/create' component={CreateHomeScreenBanner} />
    <Route exact path='/home-screen-banner/:id' component={UpdateHomeScreenBanner} />
  </Switch>
)